import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { loadSeoConfig, applySeo, setJsonLd, organizationLd } from './seo';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
let measurementId = null;
const queue = [];

const gtag = (...args) => { if (queue.length < 50) queue.push(args); };

const initAnalytics = (id) => {
  if (!id || measurementId) return;
  measurementId = id;
  const s = document.createElement('script');
  s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtagFn() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
    window.gtag('js', new Date());
  }
  window.gtag('config', id, { send_page_view: false });
  queue.splice(0).forEach((a) => window.gtag(...a));
};

const isAdmin = () => window.location.pathname.startsWith('/admin');

export const track = (name, params = {}) => {
  if (isAdmin()) return;
  (window.gtag || gtag)('event', name, params);
  if (name === 'begin_checkout' || name === 'purchase') axios.post(`${BACKEND}/api/track/event`, { name, value: params.value ?? null }).catch(() => {});
};

let firstView = true;


export const trackPurchase = (purchase) => {
  if (!purchase?.transaction_id) return;
  const key = `ga_purchase_${purchase.transaction_id}`;
  if (localStorage.getItem(key)) return;
  localStorage.setItem(key, '1');
  track('purchase', purchase);
  loadSeoConfig().then((c) => {
    if (c.ads_conversion_label && window.gtag && !isAdmin()) window.gtag('event', 'conversion', { send_to: c.ads_conversion_label, value: purchase.value, currency: purchase.currency || 'AUD', transaction_id: purchase.transaction_id });
  });
};

const addGscTag = (code) => {
  if (!code || document.head.querySelector('meta[name="google-site-verification"]')) return;
  const m = document.createElement('meta'); m.name = 'google-site-verification'; m.content = code; document.head.appendChild(m);
};

// Mounted once, before <Routes>: resets SEO defaults then logs a page view on every route change.
export const RouteTracker = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    loadSeoConfig().then((c) => {
      addGscTag(c.gsc_verification);
      initAnalytics(c.ga_measurement_id);
      setJsonLd('org', organizationLd(c));
    });
  }, []);
  useEffect(() => {
    applySeo({});
    if (isAdmin()) return undefined;
    const t = setTimeout(() => {
      // Google's tag tracks page changes itself; only GA4 (configured with send_page_view off) needs manual views.
      if (measurementId) track('page_view', { page_title: document.title, page_location: window.location.href, page_path: pathname + search });
      const q = new URLSearchParams(search);
      const body = { path: pathname, title: document.title, entry: firstView };
      if (firstView) {
        const ads = q.get('gclid') && !q.get('utm_source');
        Object.assign(body, { referrer: document.referrer || '', utm_source: q.get('utm_source') || (ads ? 'google' : ''), utm_medium: q.get('utm_medium') || (ads ? 'cpc' : ''), utm_campaign: q.get('utm_campaign') || (ads ? 'google-ads-auto' : '') });
      }
      firstView = false;
      axios.post(`${BACKEND}/api/track/pageview`, body).catch(() => {});
    }, 800);
    return () => clearTimeout(t);
  }, [pathname, search]);
  return null;
};
